//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      show: false,
      message: ""
    };
  },
  methods: {
    showPopup() {
      this.show = true;
    },
    // 确认事件
    Submit() {
      // alert('提交')
      if (!this.message) {
        // this.$msg.alert("请输入信息");
        return;
      }
      this.show = false;
      console.log(this.message);
      this.$msg.succ("提交成功");
    },
    // 取消事件
    Cancel() {
      // alert('取消')
      this.show = false;
    }
  },
  components: {}
};
